﻿﻿export interface IContactOverridePrimaryAddressRequest {
    street: string;
    city: string;
    state: string;
    postalCode: string;
}
